// Recursively trims leading/trailing whitespace from every string value.
// Works on nested objects and arrays. Pass `excludeKeys` for top-level
// object keys that must be left untouched (e.g. passwords).
export const trimStringValues = (value, excludeKeys = []) => {
    if (value == null) return value;

    // Trim primitive strings
    if (typeof value === "string") return value.trim();

    // Recurse into arrays
    if (Array.isArray(value)) return value.map((v) => trimStringValues(v, excludeKeys));

    // Recurse into objects
    if (typeof value === "object") {
        const out = {};
        Object.keys(value).forEach((key) => {
            if (excludeKeys.includes(key)) {
                out[key] = value[key];
            } else {
                out[key] = trimStringValues(value[key], excludeKeys);
            }
        });
        return out;
    }

    // Leave numbers, booleans, dates, etc. untouched
    return value;
};

// Returns true when a value should be considered "empty" for required-field checks.
// - undefined/null => empty
// - string of only whitespace or empty string => empty
// - number that is NaN => empty
export const isEmptyValue = (v) => {
    if (v === undefined || v === null) return true;
    if (typeof v === "string") return v.trim() === "";
    if (typeof v === "number") return Number.isNaN(v);
    return false;
};

// Validate top-level required keys on an object. Returns { ok, missing }.
// Note: Keys are treated as direct properties (no path support).
const getByPath = (obj, path) => {
    if (!obj || !path) return undefined;
    const parts = String(path).split('.');
    let cur = obj;
    for (const p of parts) {
        if (cur == null) return undefined;
        cur = cur[p];
    }
    return cur;
};

export const validateRequired = (obj = {}, requiredKeys = []) => {
    const missing = [];
    requiredKeys.forEach((key) => {
        const val = key.includes('.') ? getByPath(obj, key) : obj[key];
        if (isEmptyValue(val)) missing.push(key);
    });
    return { ok: missing.length === 0, missing };
};
